import { Box, useMediaQuery, useTheme } from "@mui/material";
import {
  FooterBottomContainer,
  FooterContainer,
  FooterElementContainer,
  FooterUpperContainer,
} from "../../styles/footer";
import { FlexContainer, ItemText2, ItemText5 } from "../../styles";
import InstagramIcon from "@mui/icons-material/Instagram";
// import XIcon from "@mui/icons-material/X";
// import YouTubeIcon from "@mui/icons-material/YouTube";
// import LinkedInIcon from "@mui/icons-material/LinkedIn";
import { Link } from "react-router-dom";
import openWhatsApp from "../../utils/openWhatsApp";
import { footerLegalGroups } from "../../features/Legal/data/legalPages";

export default function Footer() {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <FooterContainer>
      <FooterUpperContainer>
        <FooterElementContainer flexDirection="column" order={matches ? 1 : 5}>
          <FlexContainer mb={1}>
            <ItemText2>تواصل معنا</ItemText2>
            <Box sx={{ fontWeight: "bold" }} ml={0.5}>
              |
            </Box>
          </FlexContainer>
          <FlexContainer
            flexDirection="column"
            sx={{ alignItems: "end", gap: "4px" }}
          >
            <ItemText5
              onClick={() => openWhatsApp(matches)}
              sx={{ cursor: "pointer" }}
            >
              واتس اب: +1 289 678 8399{" "}
            </ItemText5>
            <a href="mailto:info@wswinner.com">
              <ItemText5>info@wswinner.com : ايميل </ItemText5>
            </a>
          </FlexContainer>
        </FooterElementContainer>

        <FooterElementContainer flexDirection="column" order={matches ? 2 : 4}>
          <FlexContainer mb={1}>
            <ItemText2> .. روابط مهمة</ItemText2>
            <Box sx={{ fontWeight: "bold" }} ml={0.5}>
              |
            </Box>
          </FlexContainer>
          <FlexContainer
            flexDirection="column"
            sx={{ alignItems: "end", gap: "4px" }}
          >
            <Link to={footerLegalGroups.important[0].path}>
              <ItemText5>{footerLegalGroups.important[0].title}</ItemText5>
            </Link>
            <Link to="/shop">
              <ItemText5>صفحة المتجر </ItemText5>
            </Link>
          </FlexContainer>
        </FooterElementContainer>

        <FooterElementContainer flexDirection="column" order={matches ? 3 : 3}>
          <FlexContainer mb={1}>
            <ItemText2> الطلب و الشحن</ItemText2>
            <Box sx={{ fontWeight: "bold" }} ml={0.5}>
              |
            </Box>
          </FlexContainer>
          <FlexContainer
            flexDirection="column"
            sx={{ alignItems: "end", gap: "4px" }}
          >
            <Link to={footerLegalGroups.order[0].path}>
              <ItemText5>{footerLegalGroups.order[0].title}</ItemText5>
            </Link>
            <Link to={footerLegalGroups.order[1].path}>
              <ItemText5>{footerLegalGroups.order[1].title}</ItemText5>
            </Link>
          </FlexContainer>
        </FooterElementContainer>

        <FooterElementContainer flexDirection="column" order={matches ? 4 : 2}>
          <FlexContainer mb={1}>
            <ItemText2> روابط اخرى</ItemText2>
            <Box sx={{ fontWeight: "bold" }} ml={0.5}>
              |
            </Box>
          </FlexContainer>
          <FlexContainer
            flexDirection="column"
            sx={{ alignItems: "end", gap: "4px" }}
          >
            <Link to={footerLegalGroups.policies[0].path}>
              <ItemText5>{footerLegalGroups.policies[0].title}</ItemText5>
            </Link>
            <Link to={footerLegalGroups.policies[1].path}>
              <ItemText5>{footerLegalGroups.policies[1].title}</ItemText5>
            </Link>
          </FlexContainer>
        </FooterElementContainer>

        <FooterElementContainer flexDirection="column" order={matches ? 5 : 1}>
          <FlexContainer mb={1}>
            <ItemText2> إخلاء المسؤولية</ItemText2>
            <Box sx={{ fontWeight: "bold" }} ml={0.5}>
              |
            </Box>
          </FlexContainer>
          <FlexContainer
            flexDirection="column"
            sx={{ alignItems: "end", gap: "4px" }}
          >
            <ItemText5 sx={{ direction: "rtl" }}>
              ليس بالضروره ان تكون جميع المنتجات والبيانات الموجودة على هذا
              الموقع قد قيمة من قبل إدارة الغذاء والدواء في البلد الخاص بك وليس
              المقصود منها تشخيص أي مرض أو علاجه أو الوقاية منه.
            </ItemText5>
          </FlexContainer>
        </FooterElementContainer>
      </FooterUpperContainer>

      <FooterBottomContainer>
        <FlexContainer ml={2}>
          <a
            href="https://www.instagram.com/wswinnerofficial/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <InstagramIcon />
          </a>
          {/* <XIcon />
          <YouTubeIcon />
          <LinkedInIcon /> */}
        </FlexContainer>

        <FlexContainer mr={2}>
          <Link to={footerLegalGroups.policies[0].path}>
            <ItemText2>شروط الاستخدام</ItemText2>
          </Link>
          <Box sx={{ fontWeight: "bold" }} ml={1} mr={1}>
            |
          </Box>
          <Link to={footerLegalGroups.policies[1].path}>
            <ItemText2>سياسة الخصوصية</ItemText2>
          </Link>
        </FlexContainer>
      </FooterBottomContainer>
    </FooterContainer>
  );
}
